// Ambil token dari localStorage
export const getToken = () => {
  return localStorage.getItem('token');
};

// Decode JWT token untuk mendapatkan payload dan waktu kedaluwarsa
export const decodeToken = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Failed to decode token', error);
    return null;
  }
};

// Periksa apakah token sudah kedaluwarsa atau tidak
export const isTokenExpired = (token) => {
  if (!token) return true;

  const decoded = decodeToken(token);
  if (!decoded || !decoded.exp) return true;

  const expirationDate = decoded.exp * 1000; // `exp` dalam detik, konversi ke milidetik
  return Date.now() >= expirationDate;
};

// Hapus token dari localStorage
export const removeToken = () => {
  localStorage.removeItem('token');
};

// Auto refresh jika token expired atau dihapus
export const setupAutoRefresh = () => {
  const token = getToken();

  // Jika tidak ada token, cukup berhenti (tidak perlu refresh terus-menerus)
  if (!token) {
    console.warn('No token found. Skipping auto refresh.');
    return;
  }

  // Cek apakah token sudah kedaluwarsa
  if (isTokenExpired(token)) {
    console.warn('Token is expired. Removing token and refreshing page once.');
    removeToken();
    window.location.reload(); // Refresh halaman sekali
    return;
  }

  // Timer untuk menghapus token setelah 5 jam
  const FIVE_HOURS = 5 * 60 * 60 * 1000; // 5 jam dalam milidetik
  setTimeout(() => {
    console.warn('Token expired after 5 hours. Removing token and refreshing page.');
    removeToken();
    window.location.reload(); // Refresh halaman sekali setelah 5 jam
  }, FIVE_HOURS);
};
